export enum THEME_TYPES {
  DEFAULT = 'DEFAULT',
  BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK = 'BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK',
  // Collection-promo-banner text themes (Contentful field values).
  PROMO_BLACK_TEXT = 'PROMO_BLACK_TEXT',
  PROMO_WHITE_TEXT = 'PROMO_WHITE_TEXT',
}
